import type { LabeledStat } from '@/components/common/StatCardGrid';
import { getActiveStatCard, getInactiveStatCard } from '@/utils/activeStatCards';
import type {
  PromoDistributionResponse,
  PromoItemResponse,
  PromoItemTypeResponse,
  UserPromoResponse,
} from '../types/promotion.types';

function getItemTypeCountStatCard(itemTypes: number | undefined): LabeledStat {
  return { key: 'itemTypes', label: 'Item Types', value: itemTypes };
}

function getItemCountStatCard(items: number | undefined): LabeledStat {
  return { key: 'items', label: 'Items', value: items };
}

export function getPromoItemTypeStatCards(
  meta: PromoItemTypeResponse['meta'] | undefined,
): LabeledStat[] {
  return [
    getItemTypeCountStatCard(meta?.total),
    getActiveStatCard(meta?.totals),
    getInactiveStatCard(meta?.totals),
    getItemCountStatCard(meta?.totals.items),
  ];
}

export function getPromoItemStatCards(meta: PromoItemResponse['meta'] | undefined): LabeledStat[] {
  return [
    getItemCountStatCard(meta?.total),
    getActiveStatCard(meta?.totals),
    getInactiveStatCard(meta?.totals),
    getItemTypeCountStatCard(meta?.totals.itemTypes),
  ];
}

export function getPromoAdjustmentStatCards(
  meta: PromoDistributionResponse['meta'] | undefined,
): LabeledStat[] {
  return [
    getItemCountStatCard(meta?.total),
    { key: 'distributedQty', label: 'Distributed Qty', value: meta?.totals.distributedQty },
  ];
}

export function getUserPromoStatCards(meta: UserPromoResponse['meta'] | undefined): LabeledStat[] {
  return [
    {
      key: 'assignments',
      label: 'Assignments',
      value: meta?.total,
    },
    getActiveStatCard(meta?.totals),
    { key: 'users', label: 'Users', value: meta?.totals.users },
    {
      key: 'totalQty',
      label: 'Total Qty',
      value: meta?.totals.totalQty,
    },
  ];
}
